var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDeleteRestore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 46,
    viewBox: "0 0 64 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9998 45.5H61.2498C62.4798 45.5 63.4998 44.48 63.4998 43.25V2.75C63.4998 1.52 62.4798 0.5 61.2498 0.5H22.9998C22.3998 0.5 21.8298 0.739999 21.4098 1.16L1.15982 21.41C0.289824 22.28 0.289824 23.72 1.15982 24.59L21.4098 44.84C21.8298 45.26 22.3998 45.5 22.9998 45.5ZM58.9998 41H23.9298L5.92982 23L23.9298 5H58.9998V41ZM52.2498 12.68L41.9298 23L52.2498 33.32L49.0698 36.5L38.7498 26.18L28.4298 36.5L25.2498 33.32L35.5698 23L25.2498 12.68L28.4298 9.5L38.7498 19.82L49.0698 9.5L52.2498 12.68Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeleteRestore);
export default __webpack_public_path__ + "static/media/ic-delete-restore.cfb553ab1546ccf87bd57472672566d3.svg";
export { ForwardRef as ReactComponent };